module.exports = __webpack_public_path__ + "img/founder.adefec7f.png";